import { render, staticRenderFns } from "./cpt-welcome.vue?vue&type=template&id=8da0bc5e&scoped=true"
import script from "./cpt-welcome.vue?vue&type=script&lang=js"
export * from "./cpt-welcome.vue?vue&type=script&lang=js"
import style0 from "./cpt-welcome.vue?vue&type=style&index=0&id=8da0bc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da0bc5e",
  null
  
)

export default component.exports